import gameData from "../../gameData";
import sKey from "../../SoundAssetKeys";
import { fillDot, unFillDot } from "../inGame/menuUI";
import { textIn } from "../inGame/tweenTimelines";
import { cleanUpFrost, createChooseFrost, frostTweenOut } from "./chooseFrost";
import { cleanUpShape, createChooseShape, shapeTweenOut } from "./chooseShape";
import { cleanUpSprinkleC, createChooseSprinkleC, sprinkleCOut } from "./chooseSpinkleColor";
import { cleanUpPlacedSprinkles, cleanUpSprinkle, createChooseSprinkle, sprinkleTweenOut } from "./chooseSprinkle";
import { cleanUpEat, eatDonut } from "./eatDonut";

export async function backBut(scene)
{
    scene.nextBut.disableInteractive();
    scene.backBut.disableInteractive();

    switch(gameData.makeData.index)
    {
        case 1://Frosting to choose Donut shape
            textInNextBack(scene,0);
            toggleBack(scene);
            await frostTweenOut(scene,true);
            unFillDot(1);
            cleanUpFrost(scene);
            await createChooseShape(scene);
            resetButtons(scene);

            break;
        case 2://Choose sprinkleShape
            textInNextBack(scene,1);
            await sprinkleTweenOut();
            unFillDot(2);
            cleanUpSprinkle(scene);
            cleanUpPlacedSprinkles(scene);
            await createChooseFrost(scene);
            resetButtons(scene);
            break;
        case 3:
            if(gameData.makeData.sprinkle)//Used to skip choose sprinkle color if not sprinkle is choosen
            {
                textInNextBack(scene,2);
                await sprinkleCOut();//Sprinkle color to sprinkle shape
                unFillDot(3);
                resetSprinkleColors(scene);
                cleanUpSprinkleC();
                await createChooseSprinkle(scene);
                resetButtons(scene);
            }
            else
            {
                textInNextBack(scene,2,true,116);//Eat donut to choose sprinkle shape
                await toggleNext(scene);
                unFillDot(3);
                unFillDot(4);
                cleanUpEat(scene);
                await createChooseSprinkle(scene);
                resetButtons(scene);
            }
            break;
        case 4://if choose sprinkle shape was selected, eat donut return to sprinkle color
            unFillDot(4);
            await toggleNext(scene);
            textInNextBack(scene,3,true,116);
            cleanUpEat(scene);
            await createChooseSprinkleC(scene);
            resetButtons(scene);
            
            break;
    }
}

export async function nextBut(scene)
{
    scene.nextBut.disableInteractive();
    scene.backBut.disableInteractive();
    switch(gameData.makeData.index)
    {
        case 1://First screen to choose shape
            textInNextBack(scene,0,true,116);
            fillDot(0);
            await createChooseShape(scene);
            resetButtons(scene);
            break;
        case 2://Choose shape to choose frosting
            toggleBack(scene);
            textInNextBack(scene,1);
            await shapeTweenOut(scene);
            fillDot(1);
            cleanUpShape(scene);
            await createChooseFrost(scene);
            resetButtons(scene);
            break;
        case 3://Choose frosting to choose sprinkle shape
            textInNextBack(scene,2);
            await frostTweenOut();
            fillDot(2);
            cleanUpFrost(scene);
            await createChooseSprinkle(scene);
            resetButtons(scene);
            break;
        case 4://Choose sprinkle shape to eat donut or choose sprinkle color
            await sprinkleTweenOut();
            fillDot(3);
            cleanUpSprinkle(scene);
            if(gameData.makeData.sprinkle)
            {
                textInNextBack(scene,3);
                await createChooseSprinkleC(scene);
                resetButtons(scene);
            }
            else{
                textInNextBack(scene,4,true,192);
                await toggleNext(scene);
                fillDot(4);
                eatDonut(scene);
                resetButtons(scene);
            }
            break;
        case 5://Choose sprinkle color to eat donut
            textInNextBack(scene,4,true,192);
            fillDot(4);
            await toggleNext(scene);
            await sprinkleCOut();
            eatDonut(scene);
            resetButtons(scene);
            break;
    }
    
}

function resetButtons(scene)
{
    scene.nextBut.setInteractive();
    scene.backBut.setInteractive();
}

/** Calls for a tween to shift section label, and calls sound when complete
 * 
 * @param {Phaser.scene} scene 
 * @param {number} index - current selected section
 * @param {boolean} ySwap - if the y posistion need to be swapped
 * @param {number} y - y posistion to be swapped to
 */
function textInNextBack(scene,index,ySwap,y)
{
    let timeline = textIn(scene,gameData.makeDoText[index],ySwap,y);
    timeline.once('complete',()=>{
        switch(index)
        {
            case 0:
                scene.custSound.playSoundCustom(sKey._choose_donut_shape);
                break;
            case 1:
                scene.custSound.playSoundCustom(sKey._pick_frosting_color);
                break;
            case 2:
                scene.custSound.playSoundCustom(sKey._pick_sprinkle_shape);
                break;
            case 3:
                scene.custSound.playSoundCustom(sKey._pick_sprinkle_color);
                break;
            case 4:
                scene.custSound.playSoundCustom(sKey._donut_yummy_eat_up);
                break;
        }
    })
}

export function resetSprinkleColors(scene)
{
    scene.sprinkleCont.list.forEach(element => {
        element.clearTint();
    });
}

export function toggleBack(scene)
{
    let tween;
    if(scene.backBut.scale === 1)
    {
        tween = scene.tweens.add({
            targets: scene.backBut,
            duration:500,
            //x:-190,
            scale:0,
            ease: Phaser.Math.Easing.Quadratic.In
        });
    }
    else
    {
        tween = scene.tweens.add({
            targets: scene.backBut,
            duration:500,
            //x:118,
            scale:1,
            ease: Phaser.Math.Easing.Quadratic.In
        });
    }
}

export function toggleNext(scene)
{
    return new Promise(resolve =>{
        let tween;
        if(scene.nextBut.scale === 1)
        {
            tween = scene.tweens.add({
                targets: scene.nextBut,
                duration:500,
                //x:1200,
                scale:0,
                ease: Phaser.Math.Easing.Quadratic.In
            });
        }
        else
        {
            tween = scene.tweens.add({
                targets: scene.nextBut,
                duration:500,
                //x:892,
                scale:1,
                ease: Phaser.Math.Easing.Quadratic.In
            });
        }
        tween.on('complete',()=>{resolve()});
    });
    //tween.on('complete',()=>{resetButtons(scene)});    
}